import { render, staticRenderFns } from "./Re-Order.vue?vue&type=template&id=460c1f86&scoped=true"
import script from "./Re-Order.vue?vue&type=script&lang=js"
export * from "./Re-Order.vue?vue&type=script&lang=js"
import style0 from "./Re-Order.vue?vue&type=style&index=0&id=460c1f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c1f86",
  null
  
)

export default component.exports